// extracted by mini-css-extract-plugin
export default {"insightsInner":"ChartInsights_insightsInner__HqXvS","insights":"ChartInsights_insights__x9pV+","insight":"ChartInsights_insight__CgL7f","trend":"ChartInsights_trend__PUkQC"};